
/**
 * Module dependencies.
 */

import { combineReducers } from 'redux'
import billingByWorkspaceSlug from './billing'
import currentUser from './current-user'
import lockouts from './lockouts'
import legacyAPIUsage from './legacy-api-usage'
import metadatasBySlug from './metadata'
import metadatasOwnersBySlug from './metadata-owners'
import metadataMetrics from './metadata-metrics'
import mtus from './mtus'
import usersById from './users'
import workspacesBySlug from './workspaces'
import notificationsByWorkspaceSlug from './notifications'
import paymentsByWorkspaceSlug from './payments'
import invoicePayment from './invoice-payment'
import integrationsByWorkspaceSlug from './integrations'
import integrationSettings from './integration-settings'
import session from './session'
import sourceDebugger from './source-debugger'
import plans from './plans'
import oauth from './oauth'
import application from './application'
import activity from './activity'
import warehousesById from './warehouses'
import audiencesByWorkspaceSlug from './audiences'
import sourcesById from './sources'
import sourceStats from './source-stats'
import accountsByWorkspaceAndSourceSlug from './accounts'
import accountsBySourceId from './accounts-by-sourceid'
import sourceTrackEvents from './source-track-events'
import sourceUpgrades from './source-upgrades'
import sourceSettingsBaseData from './source-settings-base-data'
import sourceSettingsValidation from './source-settings-validation'
import sourceSlug from './source-slug'
import createSourceSettingRequest from './create-source-setting-request'
import receipt from './receipt'
import requests from './requests'
import sourceSettingIntegrations from './source-setting-integrations'
import rules from './rules'
import workspaceNotifications from './workspace-notifications'
import customers from './customers'
import tokens from './tokens'
import customer from './customer'

/**
 * Export combined reducers.
 */

export default combineReducers({
  activity,
  application,
  audiencesByWorkspaceSlug,
  billingByWorkspaceSlug,
  currentUser,
  invoicePayment,
  integrationsByWorkspaceSlug,
  integrationSettings,
  lockouts,
  legacyAPIUsage,
  metadataMetrics,
  metadatasBySlug,
  metadatasOwnersBySlug,
  mtus,
  notificationsByWorkspaceSlug,
  oauth,
  paymentsByWorkspaceSlug,
  plans,
  requests,
  session,
  sourceDebugger,
  sourcesById,
  sourceStats,
  usersById,
  warehousesById,
  workspacesBySlug,
  accountsByWorkspaceAndSourceSlug,
  accountsBySourceId,
  sourceTrackEvents,
  sourceUpgrades,
  sourceSettingsBaseData,
  sourceSettingsValidation,
  sourceSlug,
  createSourceSettingRequest,
  receipt,
  sourceSettingIntegrations,
  rules,
  workspaceNotifications,
  customers,
  tokens,
  customer
})



// WEBPACK FOOTER //
// ./reducers/index.js